import { action, intercept, makeObservable, observable } from 'mobx'
import { IValidationSchema, required, validationContext } from 'validx'
import {
  maxLength,
  mustBeValidTaxFormInputValue,
} from 'utils/validation-utils'
import ContactInfoEditorViewModel from '../../editors/ContactInfoEditorViewModel'
import PersonalInfoEditorViewModel from './PersonalInfoEditorViewModel'
import { PersonalProfileVersion } from '../PersonalProfile/PersonalProfileVersion'

export default class PersonalProfileEditorViewModel {
  readonly personalInfoVm = new PersonalInfoEditorViewModel()

  readonly contactInfoVm = new ContactInfoEditorViewModel()

  @observable occupation = ''

  private schema: IValidationSchema<this> = {
    occupation: [
      required('Occupation is required'),
      mustBeValidTaxFormInputValue(),
      maxLength(100, 'Occupation must not exceed 100 characters'),
    ],
  }

  validation = validationContext(this)

  constructor() {
    makeObservable(this)

    intercept(this, (change) => {
      this.validation.clearErrors(String(change.name))
      return change
    })
  }

  @action.bound
  validate() {
    const ownValid = this.validation.reset().validate(this.schema).isValid
    const personalValid = this.personalInfoVm.validate()
    const contactValid = this.contactInfoVm.validate()
    return ownValid && personalValid && contactValid
  }

  @action.bound
  reset(profile?: PersonalProfileVersion | null) {
    const personalInfo = profile?.personalInfo
    this.personalInfoVm.reset(
      personalInfo
        ? {
            firstName: personalInfo.firstName,
            middleInitial: personalInfo.middleInitial,
            lastName: personalInfo.lastName,
            dateOfBirth: personalInfo.dateOfBirth,
            personalTaxpayerIdentificationNumber:
              personalInfo.personalTaxpayerIdentificationNumber,
          }
        : undefined,
    )

    const contactInfo = profile?.contactInfo
    this.contactInfoVm.reset(
      contactInfo
        ? {
            email: contactInfo.email,
            phoneNumber: contactInfo.phoneNumber,
            address: {
              addressLine1: contactInfo.addressLine1,
              addressLine2: contactInfo.addressLine2,
              city: contactInfo.city,
              region: contactInfo.region,
              postalCode: contactInfo.postalCode,
              country: contactInfo.country,
            },
          }
        : undefined,
    )

    this.occupation = profile?.occupation ?? ''
    this.validation.reset()
  }
}
